var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page instagram" },
    [
      !_vm.hideHeaderComponent
        ? _c("BaseHeader", { staticClass: "header" })
        : _vm._e(),
      _c("div", { staticClass: "page__content" }, [_c("router-view")], 1),
      _vm.notification
        ? _c("notification", { attrs: { message: _vm.notification } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }